<template>
  <a-layout>
    <a-layout-sider
      collapsed-width="200"
      class="sider"
    >
      <div class="back" >
        <router-link to="/" > <HomeOutlined /> </router-link>
      </div>
      <div class="profileSpacer" aria-hidden="true"></div>
      <div class="userInfo" >
        <div class="balance">
          余额：<span style="color: #eebb3c;">{{numberToChinese(balance)}}</span> token
        </div>
      </div>

      <a-menu v-model:selectedKeys="selectedKeys" theme="light" mode="vertical" @click="goPage()">
        <a-menu-item style="margin-top: 24px;" key="works">
          <UserOutlined />
          <span class="nav-text">我的作品</span>
        </a-menu-item>
        <a-menu-item style="margin-top: 24px;" key="draft">
          <FormOutlined />
          <span class="nav-text">我的草稿</span>
        </a-menu-item>
        <a-menu-item style="margin-top: 24px;" key="account">
          <AccountBookOutlined />
          <span class="nav-text">账户余额</span>
        </a-menu-item>
        <a-menu-item style="margin-top: 24px;" key="support">
          <ToolOutlined />
          <span class="nav-text">技术支持</span>
        </a-menu-item>
      </a-menu>

      <div class="logout" @click="handleLogout">
        <LogoutOutlined />
        <span>退出登录</span>
      </div>
    </a-layout-sider>
    <a-layout>
      <a-layout-content :style="{ margin: '24px 16px 0'}">
        <div :style="{ padding: '24px', background: '#fff', minHeight: '360px', borderRadius: '10px', height: 'calc(100vh - 72px)'}">
          <router-view v-slot="{ Component }">
            <transition name="fade" mode="out-in">
              <component :is="Component" />
            </transition>
          </router-view>
        </div>
      </a-layout-content>
      <a-layout-footer style="text-align: center; height: 46px;">
        Copyright © 2014-2025深圳市深层互联科技有限公司
      </a-layout-footer>
    </a-layout>
  </a-layout>
</template>
<script setup>
  import { ref, onMounted, watch } from 'vue';
  import { useRouter, useRoute } from 'vue-router'
  import { UserOutlined, FormOutlined, AccountBookOutlined, ToolOutlined, HomeOutlined, LogoutOutlined } from '@ant-design/icons-vue';
  import axios from 'axios';
  import { message } from 'ant-design-vue';
  import { clearAuthState, isAuthExpiredError } from '@/utils/auth';
import { getApiErrorMessage } from '@/utils/apiError';

  const router = useRouter()
  const selectedKeys = ref(['works']);
  const balance = ref(0);


    // 在组件挂载时设置 selectedKeys（仅首次加载）
  onMounted(() => {
    selectedKeys.value = [router.currentRoute.value.name];
    fetchBalance();
  });
  // 仅监听router name变化
  watch(() => router.currentRoute.value.name, (name) => {
    selectedKeys.value = [name];
  })
  watch(selectedKeys, val => {
    if (val[0] == undefined) return;
    router.push('/'+val[0]);
  });

  const goPage = () => {
    // console.log('selectedKeys.value', selectedKeys.value);
    // router.push('/'+selectedKeys.value[0]);
  };
  const numberToChinese = (num) => {
    return Number(num).toLocaleString();
  };

  const ensureAuthHeader = () => {
    const token = localStorage.getItem('access_token') || '';
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }
  };

  const fetchBalance = async () => {
    ensureAuthHeader();
    try {
      const res = await axios({
        method: 'get',
        url: '/v2/user/account_balance',
      });

      if (res.data?.code === 1) {
        const data = res.data?.data || {};
        balance.value = Number(data.token_amount ?? data.balance ?? 0);
        return;
      }
      message.warning(res.data?.msg || '获取余额失败');
    } catch (error) {
      if (isAuthExpiredError(error)) {
        return;
      }
      message.error(getApiErrorMessage(error, '获取余额失败'));
    }
  };

  const handleLogout = () => {
    clearAuthState(axios);
    router.push('/');
  }

</script>
<script>
export default {
  name: 'UserCenter'
}
</script>
<style lang="less" scoped>
  .back {
    position: absolute;
    top: 24px;
    left: 24px;
    z-index: 1000;
    cursor: pointer;
    color: #6a6a6ae0;
    font-size: 24px;
    span {
      color: #6a6a6ae0;
    }
  }
  .profileSpacer {
    height: 300px;
    flex: 0 0 300px;
  }

  .sider {
    background: #ffffff !important;
    position: relative;
    min-height: 100vh;
  }

  .menu_item {
    margin-top: 24px;
  }
  .editName {
    display: flex;
    color: #000000e0;
    width: 120px;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    margin: 20px 40px;
    input {
      height: 30px;
    }
    span {
      height: 30px;
      line-height: 30px;
      max-width: 200px;
      overflow: hidden;
      text-wrap: nowrap;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

  .logout {
    position: absolute;
    left: 24px;
    right: 24px;
    bottom: 24px;
    display: flex;
    align-items: center;
    gap: 8px;
    color: #000000a6;
    cursor: pointer;
    font-size: 14px;
    padding: 10px 12px;
    border-radius: 8px;
    transition: all 0.2s;
  }

  .logout:hover {
    background: #f5f5f5;
    color: #000000e0;
  }
  // #components-layout-demo-responsive .logo {
  //   height: 32px;
  //   background: rgba(255, 255, 255, 0.2);
  //   margin: 16px;
  // }

  // .site-layout-sub-header-background {
  // background: #fff;
  // }

  // .site-layout-background {
  // background: #fff;
  // }

  // [data-theme='dark'] .site-layout-sub-header-background {
  // background: #141414;
  // }
</style>
